import { useState } from 'react';
import { Alert, Form, Input, Modal, message as toast } from 'antd';
import AxiosUtils from 'utils/axios-utils';
import { API } from 'service/api-route';
import UserPicker, { UserPickerValue } from 'pages/star-shared/components/user-picker';
import { supportError } from 'pages/support-shared/utils';

interface Props {
  open: boolean;
  onClose: () => void;
  /** Mở xong → chọn luồng vừa tạo/đã có. */
  onStarted: (threadId: number) => void;
}

/** Nhân viên chủ động nhắn một người (fan, Creator, Creator NPC, Nhân viên...) — mở kênh nếu chưa có. */
const StartModal = ({ open, onClose, onStarted }: Props) => {
  const [user, setUser] = useState<UserPickerValue>();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!user?.value) return;
    setLoading(true);
    try {
      const res: any = await AxiosUtils.post(API.supportStart, {
        userId: user.value,
        content: content.trim() || undefined,
      });
      toast.success(res?.data?.created ? 'Đã mở kênh hỗ trợ.' : 'Người này đã có kênh hỗ trợ — mở cuộc trò chuyện.');
      onStarted(res.data.threadId);
      setUser(undefined);
      setContent('');
      onClose();
    } catch (error) {
      toast.error(supportError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Nhắn hỗ trợ cho một người"
      okText="Mở cuộc trò chuyện"
      cancelText="Huỷ"
      onOk={submit}
      onCancel={onClose}
      confirmLoading={loading}
      okButtonProps={{ disabled: !user?.value }}
      destroyOnHidden
    >
      <Form layout="vertical">
        <Form.Item label="Người nhận" required>
          <UserPicker value={user} onChange={setUser} placeholder="Nhập tên/username/email (ít nhất 2 ký tự)" />
        </Form.Item>
        <Form.Item label="Tin đầu tiên (không bắt buộc)" extra="Bỏ trống: gửi tin chào mặc định của kênh hỗ trợ.">
          <Input.TextArea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            autoSize={{ minRows: 3, maxRows: 8 }}
            maxLength={4000}
          />
        </Form.Item>
      </Form>
      <Alert
        type="info"
        showIcon
        message="Người nhận thấy cuộc trò chuyện với “HP Media Hỗ trợ” trong mục Tin nhắn của app và nhận thông báo đẩy. App cũ không có nút tự mở hội thoại, nên với fan đây là cách để bắt đầu."
      />
    </Modal>
  );
};

export default StartModal;
